import { isBrowser, isMobile, isTablet } from 'mobile-device-detect';

export default function useIsDesktop() {
  // Detectar desktop: debe ser browser y no móvil ni tablet
  const isDesktopFromLib = isBrowser && !isMobile && !isTablet;
  
  // Fallback: verificar user agent directamente
  const userAgent = typeof window !== 'undefined' ? navigator.userAgent : '';
  const isDesktopFromUA = !/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent);
  
  // Usar la librería primero, pero si falla usar el fallback
  const isDesktop = isDesktopFromLib || (isDesktopFromUA && typeof window !== 'undefined' && window.innerWidth > 768);
  
  return isDesktop;
}

